<template>
  <transition name="fade">
    <sc-spinner v-if="showSpinner" :fullscreen="true"></sc-spinner>
  </transition>
</template>

<script>
import { ScSpinner } from 'smartcommerce-component-library'
import BusyService from '../services/BusyService'

export default {
  name: 'Spinner',
  components: { ScSpinner },

  data () {
    return {
      showSpinner: false
    }
  },

  created () {
    BusyService.subscribe(show => {
      this.showSpinner = show
    })
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .25s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
